import { makeStyles, MenuItem } from "@material-ui/core";

import Select from "src/components/form/Select";

const useStyles = makeStyles(() => ({
  select: {
    marginBottom: "30px"
  }
}));

export default function IntegrationTypeSelect(): JSX.Element {
  const classes = useStyles();
  return (
    <Select
      className={classes.select}
      fullWidth
      disabled
      value="van"
      label="Integration type"
    >
      <MenuItem key="van" value="van">
        NGP VAN / EveryAction
      </MenuItem>
    </Select>
  );
}
